module.exports = __webpack_public_path__ + "5a41dc7276f8fc56a3ab2dcbe2d83b79.svg";